import React, { useState, useEffect, useRef } from "react";
import "./Range.css";

function Range() {
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [accuracy, setAccuracy] = useState();
  const [pins, setPins] = useState({});
  const locationWatchId = useRef(null);

  const range = {
    white: {
      lat: 46.18654761453375,
      long: -83.0247966954225,
    },
    red: {
      lat: 46.18625476362232,
      long: -83.02411298437111,
    },
    blue: {
      lat: 46.185857537245816,
      long: -83.02405631177409,
    },
  };

  useEffect(() => {
    setLatitude("");
    setLongitude("");
    setAccuracy("");
    // setPins("");
    getLocation();
    // Clear the location watch instance when React unmounts the used component
    return cancelLocationWatch;
  }, []);

  // Clears the watch instance based on the saved watch id
  const cancelLocationWatch = () => {
    if (locationWatchId.current && navigator.geolocation) {
      navigator.geolocation.clearWatch(locationWatchId.current);
    }
  };

  const getLocation = () => {
    if (navigator.geolocation) {
      //watchPosition to get more accuracy
      // let acc;
      locationWatchId.current = navigator.geolocation.watchPosition(
        (position) => {
          // acc = position.coords.accuracy.toFixed(2);
          setAccuracy(position.coords.accuracy.toFixed(2));
          setLatitude(position.coords.latitude.toFixed(13));
          setLongitude(position.coords.longitude.toFixed(13));
          getAllDistances(position.coords.latitude, position.coords.longitude);
        },
        (error) => {
          if (error.message == "Timeout expired") {
            alert("Limited Accuracy Acheivable");
          } else {
            alert(error.message);
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 20000,
          maximumAge: 0,
          distanceFilter: 1,
        }
      );
    }
  };

  const getAllDistances = (Lat, Long) => {
    // let arr={}
    for (const [pin, { lat, long }] of Object.entries(range)) {
      // arr[pin] = getDistanceFromLatLonInYds(Lat, Long, lat, long).toFixed(0);
      setPins((prevPins) => {
        return {
          ...prevPins,
          [pin]: getDistanceFromLatLonInYds(Lat, Long, lat, long).toFixed(0),
        };
      });
    }
    // setPins(arr);
  };

  const getDistanceFromLatLonInYds = (lat1, lon1, lat2, lon2) => {
    let R = 6975240.5949256; // Radius of the earth in yards
    let dLat = deg2rad(lat2 - lat1); // deg2rad below
    let dLon = deg2rad(lon2 - lon1);
    let a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) *
        Math.cos(deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    let d = R * c; // Distance in yards
    return d;
  };

  const deg2rad = (deg) => {
    return deg * (Math.PI / 180);
  };
  // console.log("Pins", pins);

  return (
    <div>
      <table className="table__range">
        <tr>
          <th colSpan="2" className="table__title">
            Distance to Flags
          </th>
        </tr>
        <tr>
          <th className="table__subtitles">Colour</th>
          <th className="table__subtitles">Yards</th>
        </tr>

        <tr>
          <td className="yellow">Yellow</td>
          <td className="yellow"></td>
        </tr>
        <tr>
          <td className="white">White</td>
          <td className="white">{pins.white}</td>
        </tr>
        <tr>
          <td className="red">Red</td>
          <td className="red">{pins.red}</td>
        </tr>
        <tr>
          <td className="blue">Blue</td>
          <td className="blue">{pins.blue}</td>
        </tr>
      </table>
    </div>
  );
}

export default Range;
